module.exports = ".btn-group .btn{\r\n    min-width: 5px;\r\n}\r\n.btn-group i{  \r\n    color: white;\r\n}\r\n.small-icon img{\r\n    width: 30px;\r\n    cursor: pointer;\r\n}\r\n.Blue{\r\n    color:blue;    \r\n}\r\n.Green{\r\n    color:brown\r\n}\r\n.Red{\r\n    color:red;\r\n}\r\n.DGreen{\r\n    color: green\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component.css
// module id = ./src/app/Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component.css
// module chunks = main